import React, { useState, useEffect } from "react"
import { useTheme } from '~/contexts/ThemeContext'
import { notBlank, imgSize } from '~/utils/helpers'

import * as styles from "~/styles/plp/hero.module.scss"


const image_size = (url, isMobile) => {
  if (!isMobile) return imgSize(url,1400)
  return imgSize(url,900)
}


const Hero = ({ title, data }) => {
  const { isMobile } = useTheme()
  const [image, setImage] = useState(null)

  const is_image = notBlank(data.hero) && notBlank(data.hero_mobile)

  
  useEffect(() => {
    if (typeof document === 'undefined' || !is_image) return

    let show_img = data.hero
    if (isMobile && notBlank(data.hero_mobile)) show_img = data.hero_mobile
    show_img = image_size(show_img, isMobile)

    setImage(show_img)

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className={styles.wrap}>
      {image && (
        <img 
          className={styles.img} 
          src={image}
          loading="lazy" width="1400" height="500" alt={`The Buck Mason ${title} collection`}
        />
      )}
    </div>
  )
}

export default Hero





